import PersonalizedActions from './constants';
import { IActionObject } from './types';

const INITIAL_STATE: boolean = false;

export default function personalizedStopsReducer(
  state: any = INITIAL_STATE,
  action: IActionObject
): object {
  switch (action.type) {
    case PersonalizedActions.SET_PERSONALIZATION_COMPLETION:
      return action.data;
    default:
      return state;
    }
}